var map = {
	"./button.close.svg": 640,
	"./button.info.svg": 6320,
	"./button.routes.svg": 2546,
	"./data": 2802,
	"./data.json": 2802,
	"./feature.auto.png": 857,
	"./feature.barge.png": 3369,
	"./feature.bulk.png": 7916,
	"./feature.cargo.png": 6326,
	"./feature.rail.png": 9648,
	"./feature.storage.png": 4713,
	"./flag.be.png": 7137,
	"./flag.dk.png": 5321,
	"./flag.es.png": 1870,
	"./flag.ie.png": 756,
	"./flag.nl.png": 2052,
	"./flag.po.png": 7633,
	"./flag.se.png": 3354,
	"./flag.uk.png": 2022,
	"./logo.png": 3153,
	"./map.svg": 2908,
	"./office.svg": 3838,
	"./port.svg": 6583,
	"./reset.css": 9968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;